import { AppLayout } from "@/components/AppLayout";
import { HelpCircle, MessageCircle, Book, Mail, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Comment fonctionne le système de crédits ?",
    answer: "Chaque génération d'image consomme des crédits. Le nombre de crédits dépend du modèle utilisé (Floop Basic ou Floop Pro) et de la résolution choisie. Vous pouvez acheter des packs de crédits depuis la page Tarifs.",
  },
  {
    question: "Quelle est la différence entre Floop Basic et Floop Pro ?",
    answer: "Floop Basic est notre modèle IA idéal pour des générations rapides et créatives. Floop Pro est la version premium offrant des résultats de qualité studio avec plus de détails et de réalisme.",
  },
  {
    question: "Les images générées m'appartiennent-elles ?",
    answer: "Oui ! Toutes les images que vous générez avec Floop vous appartiennent. Vous pouvez les utiliser librement à des fins personnelles et commerciales.",
  },
  {
    question: "Combien de temps mes images sont-elles conservées ?",
    answer: "Vos images sont conservées dans votre historique pendant 30 jours. Nous vous recommandons de télécharger les images que vous souhaitez conserver.",
  },
  {
    question: "Puis-je obtenir un remboursement ?",
    answer: "Les crédits achetés ne sont pas remboursables sauf disposition légale contraire. Contactez notre support pour toute situation exceptionnelle.",
  },
  {
    question: "Comment améliorer la qualité de mes générations ?",
    answer: "Utilisez des prompts détaillés et précis. Spécifiez le style, l'éclairage, les couleurs et l'ambiance souhaités. Floop Pro offre généralement de meilleurs résultats pour les images complexes.",
  },
];

const Help = () => {
  return (
    <AppLayout title="Aide">
      <div className="p-6 space-y-8 max-w-4xl">
        {/* Header */}
        <div className="text-center space-y-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full">
            <HelpCircle className="w-5 h-5 text-primary" />
            <span className="text-sm font-medium text-primary">Centre d'aide</span>
          </div>
          <h1 className="text-3xl font-bold text-foreground">
            Comment pouvons-nous vous aider ?
          </h1>
          <div className="max-w-md mx-auto">
            <Input
              placeholder="Rechercher dans l'aide..."
              className="bg-input border-border rounded-xl"
            />
          </div>
        </div>

        {/* Quick Links */}
        <div className="grid md:grid-cols-3 gap-4">
          <button className="p-6 bg-card border border-border rounded-2xl text-left hover:border-primary/50 transition-colors">
            <Book className="w-8 h-8 text-primary mb-3" />
            <h3 className="font-semibold text-foreground mb-1">Documentation</h3>
            <p className="text-sm text-muted-foreground">Guides et tutoriels complets</p>
          </button>
          <button className="p-6 bg-card border border-border rounded-2xl text-left hover:border-primary/50 transition-colors">
            <MessageCircle className="w-8 h-8 text-highlight mb-3" />
            <h3 className="font-semibold text-foreground mb-1">Chat en direct</h3>
            <p className="text-sm text-muted-foreground">Parlez à notre équipe</p>
          </button>
          <button className="p-6 bg-card border border-border rounded-2xl text-left hover:border-primary/50 transition-colors">
            <Mail className="w-8 h-8 text-accent mb-3" />
            <h3 className="font-semibold text-foreground mb-1">Email</h3>
            <p className="text-sm text-muted-foreground">support@floop.ai</p>
          </button>
        </div>

        {/* FAQ */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-foreground">Questions fréquentes</h2>
          <div className="bg-card border border-border rounded-2xl">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border-border">
                  <AccordionTrigger className="px-6 hover:no-underline text-foreground">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 text-muted-foreground">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>

        {/* Contact */}
        <div className="bg-gradient-to-br from-primary/20 via-violet/20 to-accent/20 border border-primary/30 rounded-2xl p-6 text-center space-y-4">
          <h2 className="text-xl font-semibold text-foreground">Vous n'avez pas trouvé votre réponse ?</h2>
          <p className="text-muted-foreground">
            Notre équipe est là pour vous aider. Contactez-nous et nous vous répondrons rapidement.
          </p>
          <Button className="bg-gradient-floop hover:opacity-90 text-white rounded-xl">
            <Mail className="w-4 h-4 mr-2" />
            Contacter le support
          </Button>
        </div>
      </div>
    </AppLayout>
  );
};

export default Help;
